export const TRANSLATION_KEYS = {
  filter: 'jbp-composed-report-filter',
  clearFilter: 'jbp-composed-report-clear-filter',
  columnRank: 'jbp-composed-report-column-rank',
  columnPartnerId: 'jbp-composed-report-column-partner-id',
  columnPartnerName: 'jbp-composed-report-column-partner-name',
  columnCountry: 'jbp-composed-report-column-country',
  columnActualPrevYear: 'jbp-composed-report-column-actual-prev-year',
  columnActualCurrentYear: 'jbp-composed-report-column-actual-current-year',
  columnTargetPrevYear: 'jbp-composed-report-column-target-prev-year',
  columnTargetCurrentYear: 'jbp-composed-report-column-target-current-year',
  columnYoYPlan: 'jbp-composed-report-column-yoy-plan',
  columnYoYTarget: 'jbp-composed-report-column-yoy-target',
  columnPMB: 'jbp-composed-report-column-pmb',
  columnManager: 'jbp-composed-report-column-manager',
  columnURL: 'jbp-composed-report-column-url',
  columnGeoRegion: 'jbp-composed-report-column-geo-region',
  columnPartnerType: 'jbp-composed-report-column-partner-type',
  columnRTM: 'jbp-composed-report-column-rtm',
  columnSOBCategory: 'jbp-composed-report-column-sob-category',
  columnCompletion: 'jbp-composed-report-column-completion',

  linkTip: 'jbp-composed-report-link-tip',
  savedFiltersDialogOpen: 'jbp-composed-report-open',
  savedFiltersDialogSave: 'jbp-composed-report-save',
  savedFiltersDialogUpdate: 'jbp-composed-report-update',
  savedFiltersDialogCancel: 'jbp-composed-report-saved-filters-dialog-cancel',
  savedFiltersDialogHeader: 'jbp-composed-report-header',
  savedFiltersDialogName: 'jbp-composed-report-name',
  savedFiltersDialogModifiedDate: 'jbp-composed-report-modified-date',
  savedFiltersDialogKey: 'jbp-composed-report',
  savedFiltersDialogFilters: 'jbp-composed-report-filters',
  addToScope: 'jbp-composed-report-add-to-scope',
  clearScope: 'jbp-composed-report-clear-scope',
  addToScopeFromGroup: 'jbp-composed-report-add-to-scope-from-group',
  addToScopeGlobal: 'jbp-composed-report-add-to-scope-global',
  scopeDescription: 'jbp-composed-report-scope-description',
  partnersInScope: 'jbp-composed-report-partners-in-scope',
  partner360Link: 'jbp-composed-report-partner-360-link',
  openPartner360: 'jbp-composed-report-open-partner-360',
  pasteFromClipboardTitle: 'jbp-composed-report-paste-from-clipboard-title',
  openPasteFromClipboard: 'jbp-composed-report-open-paste-from-clipboard',
  openScopeEditor: 'jbp-composed-report-open-scope-editor',

  clipboardApply: 'jbp-composed-report-clipboard-apply',
  clipboardCancel: 'jbp-composed-report-clipboard-cancel',
  clipboardPayloadCount: 'jbp-composed-report-clipboard-payload-count',
  clipboardResponseCount: 'jbp-composed-report-clipboard-response-count',
  clipboardResultOk: 'jbp-composed-report-clipboard-result-ok',
  clipboardUnmatched: 'jbp-composed-report-clipboard-unmatched',

  filterWasChanged: 'jbp-composed-report-filter-was-changed',
  initialText: 'jbp-composed-report-initial-text',

  openFilterScopeField: 'jbp-composed-report-open-filter-scope-field',
  openFilterProducts: 'jbp-composed-report-open-filter-products',
  openFilterPbms: 'jbp-composed-report-open-filter-pbms',
  openFilterAmplifyMembership: 'jbp-composed-report-open-filter-membership',
  openFilterManagers: 'jbp-composed-report-open-filter-managers',
  openFilterGeo: 'jbp-composed-report-open-filter-geo',
  openFilterScopeCount: 'jbp-composed-report-open-filter-scope-count',
  openFilterPartnersType: 'jbp-composed-report-open-filter-partners-type',

  saveFilterAttention: 'jbp-composed-save-filter-attention',
  saveFilterCheckbox: 'jbp-composed-save-filter-checkbox',

  fYearField: 'jbp-composed-report-fYear-field',
  productsField: 'jbp-composed-report-products-field',
  geoField: 'jbp-composed-report-geo-field',
  scopeField: 'jbp-composed-report-scope-field',
  partnersTypeField: 'jbp-composed-report-partners-type-field',
  amplifyMembershipField: 'jbp-composed-report-amplify-membership-field',
  isAcknowledgedField: 'jbp-composed-report-is-acknowledged-field',
  dnaLoadDate: 'jbp-composed-report-dna-load-date',
}
